import { DataLoader } from '../../../core/types/data-loader';
import { StateStoreOrVoid } from '../../../core/types/application-state';
import { parseCurrentQueryString, withDefault } from '../../../core/util';
import { houseHoldSummitData } from '../../shared/summit.utils';
import { getCustomerDataById } from '../../shared/services/customer-service';
import { getCustomerHouseholdDataById } from '../../shared/services/household-service';
import { getCustodiansService } from '../../shared/services/custodian';
import { loadFONASUCustomerData } from '../shared/loaders';
import {
  consumerTypes,
  accountTypes,
  chargeTypes,
  fundingTypes,
  applicationStatusTypes
} from '../../shared/utils';
import {
  getFONASUTransferRJProgressStep,
  isMailingAddressDifferent
} from '../shared/utils';

export const makeLoadtransferData = ({
  fromIRAAccountType,
  toIRAAccountType
}): DataLoader => async (): Promise<StateStoreOrVoid> => {
  const qs = parseCurrentQueryString();
  const { bpId } = qs;

  const householdData = await getCustomerHouseholdDataById(Number(bpId));

  const summitData = houseHoldSummitData(householdData);

  const customerData = await getCustomerDataById(Number(bpId));

  const customerDataConverted = loadFONASUCustomerData(customerData);

  const mailingAddressDifferent = isMailingAddressDifferent(
    customerDataConverted
  );

  const usernameExists = !!customerData?.username?.length;
  const institutions = await getCustodiansService();

  return {
    app: {
      toIRAAccountType,
      fromIRAAccountType,
      applicationStatus: applicationStatusTypes.PUSH_TO_WEB,
      fundingType: fundingTypes.EFT,
      chargeType: chargeTypes.TRANSFER,
      customer: customerDataConverted,
      newInvestments: [],
      custodian: {
        custodianID: '',
        custodianName: ''
      },
      externalAccounts: []
    },
    accountType: accountTypes.TRANSFER,
    mailingAddressDifferent,
    loadedData: {
      institutions,
      infoValid: false,
      portfolioValid: false,
      usernameExists,
      fundingValid: false,
      loginID: withDefault(customerData?.username, ''),
      error: '',
      customerInfoEditMode: true,
      portfolioEditMode: false,
      fundingEditMode: false,
      associateLoginID: ''
    },
    summitData,
    consumerName: consumerTypes.FONASU,
    progressStep: 4,
    progressStepText: getFONASUTransferRJProgressStep(fromIRAAccountType)
  };
};
